import React, { Component, Fragment } from "react";
import Img from '../../Assets/Img/ConsultasYReclamos.jpg'
import Phone24 from "../../Assets/Icons/ART_Icon_Phone24";
import Phone from "../../Assets/Icons/ART_Icon_Phone";
import PolizaForm from "./PolizaForm";
import Cecap from "../../Assets/Icons/CECAP.png";
import Atencion from "../../Assets/Icons/ATENCION AL PUBLICO.png";
import ReactGA from 'react-ga';


export class Poliza extends Component { 

  componentDidMount(){
    window.fbq('track', 'Poliza');
    ReactGA.initialize('UA-210861270-1');
    ReactGA.pageview(window.location.pathname + window.location.search, 'POLIZA','POLIZA');
  };

  render() {

    return (

        <Fragment>

          <PolizaForm/>

          <div style={{padding: '3% 6%'/*, display: 'flex'*/, 'border': 'solid #f8a700 2px'}} >
            <div style={{color: 'rgb(150, 152, 154)'}}>
                  <h3 /*className="inicio-title"*/
                  style={{'font-weight': 'bold'}}
                  >Tutoriales sobre Póliza Digital de la SRT</h3>
            </div>

            <div style={{'margin-left': '5%'}}> 

              <a style={{display: 'list-item', color: '#f8a700'}} 
                href="https://www.youtube.com/watch?v=n0mpLwOo4B4" target="_blank">
                <h6>Adhesión a e-Servicios SRT </h6>
              </a>
            
              <a style={{display: 'list-item', color: '#f8a700'}} 
                href="https://www.youtube.com/watch?v=qSSqZYFMsXU" target="_blank">
                <h6>Certificado de No Objeción </h6>
              </a>

              <a style={{display: 'list-item', color: '#f8a700'}} 
              /*href="https://www.youtube.com/watch?v=D4VLMmDgcx4" target="_blank">*/
                href="https://www.youtube.com/watch?v=hRZWtIchs-w" target="_blank">
                <h6>Servicio de Póliza Digital de Riesgos del Trabajo </h6>
              </a>
            </div>
          </div>
          

     </Fragment>

    );
  }
}

export default Poliza;
